import { Position, Toaster } from '@blueprintjs/core';

/** Singleton toaster instance. Create separate instances for different options.
 * Implemented in global file because the Toaster instance cannot be created as part of
 * the component lifecycle.
 * See React 16 Usage note in Blueprint docs: https://blueprintjs.com/docs/#core/components/toast.toaster
 */
const _Toaster = Toaster.create({ position: Position.TOP });

export default _Toaster;
